import Web3Modal from 'web3modal'

export const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const web3Modal = new Web3Modal({
            network: 'mumbia',
            cacheProvider: true,
          });
        await web3Modal.connect()
        const addressArray = await window.ethereum.request({
            method: 'eth_requestAccounts',
        })
        const obj = {
          status: 'Wallet successfuly connected.',
          address: addressArray[0],
        }
        return obj
      } catch (err) {
        return {
          address: '',
          status: 'Something went wrong: ' + err.message,
        }
      }
    } else {
      return {
        address: '',
        status: (
          <span>
            <p>
              {' '}
              🦊{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      }
    }
  }
  
  export const getCurrentWalletConnected = async () => {
    if (window.ethereum) {
      try {
        const addressArray = await window.ethereum.request({
          method: 'eth_accounts',
        })
        if (addressArray.length > 0) {
          return {
            address: addressArray[0],
            status: 'Connected',
          }
        } else {
          return {
            address: '',
            status: '🦊 Connect to Metamask using the top right button.',
          }
        }
      } catch (err) {
        return {
          address: '',
          status: 'Something went wrong: ' + err.message,
        }
      }
    } else {
      return {
        address: '',
        status: (
          <span>
            <p>
              {' '}
              🦊{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      }
    }
  }

  export const removeExponents = (strNumber) => {
    var data= String(strNumber).split(/[eE]/);
    if(data.length=== 1) return data[0]; 

    var  z= '', sign= strNumber<0? '-':'',
    str= data[0].replace('.', ''),
    mag= Number(data[1])+ 1;

    if(mag<0){
        z= sign + '0.';
        while(mag++) z += '0';
        return z + str.replace(/^\\-/,'');
    }
    mag -= str.length;  
    while(mag--) z += '0';
    return str + z;
}
  